module.exports = __webpack_public_path__ + "img/orange-circle-table-4.2e6b3d6b.png";